// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"1220":"admin.booths.show.edit-canvas","3778":"admin.metrics.print","9488":"admin.metrics.index"}[chunkId] || chunkId) + "." + {"1220":"0ae5ab54","1580":"2cae9e4e","3778":"d3ad589b","9488":"c24ba7f5"}[chunkId] + ".css";
};